import { useEffect, useRef } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { MapPin } from "lucide-react";

export default function AddressAutocomplete({ value, onChange, onSelect, placeholder, testId }) {
  const places = useMapsLibrary("places");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!places || !inputRef.current) return;
    const ac = new places.Autocomplete(inputRef.current, {
      fields: ["formatted_address", "geometry", "name"],
      componentRestrictions: { country: "us" },
    });
    const listener = ac.addListener("place_changed", () => {
      const p = ac.getPlace();
      if (p.geometry?.location) {
        const address = p.formatted_address || p.name;
        onChange(address);
        onSelect({ address, lat: p.geometry.location.lat(), lng: p.geometry.location.lng() });
      }
    });
    return () => listener.remove();
  }, [places]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative">
      <MapPin size={15} className="text-primary absolute left-3 top-1/2 -translate-y-1/2 z-10" />
      <input
        ref={inputRef}
        data-testid={testId}
        defaultValue={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-12 pl-9 pr-3 bg-secondary border border-white/10 text-foreground text-sm rounded-none placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
      />
    </div>
  );
}
